import { idb } from "../../idb.js";
import { retryIntervalInMillis } from "./data/log-queue-config.js";
import { drainQueue } from "./drain-queue.js";

let started = false;

export const startRetryTimer = () => {
  if (started) {
    return;
  }

  started = true;

  setInterval(() => drainQueue(idb), retryIntervalInMillis);
};
